import React, { useEffect } from 'react';
import './EvaluationCriteria.css';
import CriteriaTemplate from './CriteriaTemplate/CriteriaTemplate';
import CriteriaText from './CriteriaText/CriteriaText';

const EvaluationCriteria = ({
    account,
    session,
    factor,
    currentStep,
    currentSubPage,
    maxSubPage,
    setCurrentStep,
    setCurrentSubPage,
    setMaxSubPage,
    answerFactor,
    setAnswerFactor,
    setStepInComplete,
    setSubPageInComplete,
    setValidationMessage
}) => {
    useEffect(() => {
        setMaxSubPage(factor.length - 1);
    }, [factor, setMaxSubPage]);

    const factors = factor.filter(a => a.grading);
    

    const calculateFinalScore = (summaryAnswer, factorL) => {
        let finalScore = 0;

        summaryAnswer.forEach(answer => {
            const ft = factorL.find(f => f.factor_id === answer.key);
            if (ft) {
                const inputGrade = answer.data.grade;
                const weight = ft.weight;

                const factorScore = inputGrade * (weight / 100)
                finalScore += factorScore;
            }
        });

        return finalScore;
    };

    useEffect(() => {
        if (!answerFactor) return;
        setMaxSubPage(factor.length - 1);
        const finalScore = calculateFinalScore(answerFactor.factors, factors);
        setAnswerFactor(prev => ({
            ...prev,
            final_grade: finalScore
        }));
    }, [currentStep, answerFactor]);


    const currentFactor = factor[currentSubPage]; //current display
    const currentFactorAnswer = answerFactor.factors?.find(
        (f) => f.key === currentFactor.factor_id
    ) || { key: currentFactor.factor_id, data: null };

    return (
        <div className="evaluation-criteria-container h-100">
            {currentFactor && currentFactor.factor_id && currentFactor.general_evaluation?.show ? (
                <CriteriaText
                    account={account}
                    session={session}
                    setAnswerFactor={setAnswerFactor}
                    currentAnswer={answerFactor}
                    data={currentFactor}
                    setSubPageInComplete={setSubPageInComplete}
                />
            ) : (
                currentFactor && currentFactorAnswer && (
                    <CriteriaTemplate
                        factorData={currentFactor}
                        setAnswerFactor={setAnswerFactor}
                        currentAnswer={currentFactorAnswer}
                        setSubPageInComplete={setSubPageInComplete}
                    />
                )
            )}
        </div>
    );
};

export default EvaluationCriteria;
